module.exports = function(app) {
	'use strict';

	app.directive('eprDependentReview', function () {
		return {
			templateUrl: '_directives.employerTemplate.html/directives/employee/eprDependentReview',
			restrict: 'A',
			replace: true,

			scope: {
				employee: '=eprDependentReview',
				editMode: '=?',
				onEditPage: '=?'
			},

			controller: ['$scope', 'employee', 'addFlowCommander', '$timeout', '$state', 'coremetrics','storage',
				function($scope, employee, addFlowCommander, $timeout, $state, coremetrics,storage) {
                	$scope.onEditPage = $scope.onEditPage ? $scope.onEditPage : null;

					$scope.tryToAddDependent = function() {
						storage.set('AddDependent',"1");
						coremetrics.startConversion('EMPLOYERS:ENROLLMENT:ADD DEPENDENT','EMPLOYERS:ENROLLMENT');
						coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE SUBSCRIBERS AND DEPENDENT','EMPLOYERS:ENROLLMENT');
						switch ($state.current.name) {
							case 'employee.find.review':
								coremetrics.elementTag('ADD DEPENDENTS', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						if (employee.data.dependents.length > 24) { // max is 25
							$scope.flash.addMessage('Max Dependents Reached!');
							return;
						}
						addFlowCommander.addDependent($scope.employee);
					};

					$scope.isInAddFlow = addFlowCommander.isInAddFlow;

                    $scope.removeDependent = function(dependent) {

                        var dependentIndex = $scope.employee.data.dependents.indexOf(dependent);
                        if (dependentIndex >= 0) {
                            $scope.employee.data.dependents.splice(dependentIndex, 1);
                        }

                        // Check to update the side bar when  MNLOA and Other Ins and medicare are deleted .
                        addFlowCommander.sidebar.update();
                    };


                }
			]
		};
	});

	app.directive('focusOn', function () {
		return {
			link: function (scope, elem, attr) {
				if (attr.focusOn === undefined || attr.focusOn === 'true') {
					elem.focus();
				}
			}
		};
	});
};
